import React, { useState } from "react";
import { toast } from "react-toastify";
import { authService } from "../services/authService";

const LoginPage = ({ onLogin }) => {
  const [isAdminLogin, setIsAdminLogin] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    console.log("Attempting login with:", {
      username: formData.username,
      password: "***",
    });

    try {
      const response = await authService.login(
        formData.username,
        formData.password
      );

      console.log("Login successful:", response);

      // Check if user role matches the selected login type
      const userRole = response.user.role;
      const userAccountType = response.user.accountType;

      if (
        isAdminLogin &&
        userRole !== "admin" &&
        userAccountType !== "business"
      ) {
        toast.error("Access denied. Business credentials required.");
        setLoading(false);
        return;
      }

      if (
        !isAdminLogin &&
        userRole !== "user" &&
        userAccountType !== "regular_user"
      ) {
        toast.error("Access denied. User credentials required.");
        setLoading(false);
        return;
      }

      toast.success(`Welcome ${response.user.username}!`);
      onLogin(response.user, response.token);
    } catch (error) {
      console.error("Login error details:", {
        message: error.message,
        response: error.response,
        status: error.response?.status,
        data: error.response?.data,
      });

      // Handle different types of errors
      if (error.response?.status === 401) {
        toast.error("Invalid username or password");
      } else if (error.response?.status === 400) {
        toast.error(error.response?.data?.message || "Invalid input");
      } else if (error.response?.status === 500) {
        toast.error("Server error. Please try again later.");
      } else if (error.code === "NETWORK_ERROR" || !error.response) {
        toast.error("Network error. Please check your connection.");
      } else {
        toast.error(error.response?.data?.message || "Login failed");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="card" style={{ maxWidth: "400px", margin: "50px auto" }}>
        <div className="text-center mb-20">
          <h1>Welcome to User Management</h1>
          <p>Please select your account type and login</p>
        </div>

        {/* Account Type Toggle */}
        <div className="toggle-container" style={{ justifyContent: "center" }}>
          <span style={{ fontWeight: isAdminLogin ? "normal" : "bold" }}>
            User Account
          </span>
          <label className="toggle">
            <input
              type="checkbox"
              checked={isAdminLogin}
              onChange={(e) => setIsAdminLogin(e.target.checked)}
            />
            <span className="slider"></span>
          </label>
          <span style={{ fontWeight: isAdminLogin ? "bold" : "normal" }}>
            Business Account
          </span>
        </div>

        <div className="text-center mb-20">
          <h2 style={{ color: isAdminLogin ? "#dc3545" : "#667eea" }}>
            {isAdminLogin ? "Business Login" : "User Login"}
          </h2>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Username or Email</label>
            <input
              type="text"
              name="username"
              className="form-input"
              value={formData.username}
              onChange={handleInputChange}
              required
              placeholder="Enter your username or email"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              name="password"
              className="form-input"
              value={formData.password}
              onChange={handleInputChange}
              required
              placeholder="Enter your password"
            />
          </div>

          <div className="form-group">
            <button
              type="submit"
              className={`btn ${isAdminLogin ? "btn-danger" : "btn-primary"}`}
              style={{ width: "100%" }}
              disabled={loading}
            >
              {loading
                ? "Logging in..."
                : `Login as ${isAdminLogin ? "Business" : "User"}`}
            </button>
          </div>
        </form>

        <div className="text-center mt-20">
          <div
            style={{
              padding: "20px",
              backgroundColor: "#f8f9fa",
              borderRadius: "12px",
              border: "1px solid #e9ecef",
            }}
          >
            <p
              style={{
                margin: "0 0 15px 0",
                color: "#6c757d",
                fontSize: "14px",
              }}
            >
              Don't have an account?
            </p>
            <button
              type="button"
              onClick={() => (window.location.href = "/register")}
              className="btn btn-outline-primary"
              style={{
                width: "100%",
                padding: "12px 24px",
                fontSize: "16px",
                fontWeight: "600",
                borderRadius: "8px",
                transition: "all 0.3s ease",
                border: "2px solid #007bff",
                backgroundColor: "transparent",
                color: "#007bff",
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#007bff";
                e.target.style.color = "white";
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 4px 12px rgba(0,123,255,0.3)";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "transparent";
                e.target.style.color = "#007bff";
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "none";
              }}
            >
              ✨ Create New Account
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
